import { filter } from 'lodash';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Card,
  Button,
  Table,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  Container,
  TableContainer,
  TablePagination,
  Stack,
  styled,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Controls from '../../components/controls/Controls';
import { baseUrl, userDept, userStatuses } from '../../utils/constants';
import SearchNotFound from '../../components/SearchNotFound';
import { ClientListHead, ClientListToolbar } from '../../components/_dashboard/clients';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const TABLE_HEAD = [
  { id: 'userName', label: 'User Name', alignRight: false },
  { id: 'firstName', label: 'First Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: true },
  { id: 'status', label: 'Status', alignRight: true },
  { id: 'department', label: 'Department', alignRight: true },
  { id: 'actions', label: '', alignRight: true }
];

export default function ConfigUsers() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dataList, setDataList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('userName');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });

  const navigate = useNavigate();

  useEffect(() => {
    getUsers();
  }, []);

  // const getUsers = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `${baseUrl}/api/userManagement/GetAllUsers?step=0&skip=100&orderBy=refId&order=true&filter=a&currentCountryOnly=false&activeUsersOnly=false`
  //     );
  //     console.log('users returned', response);
  //     setDataList(response.data.users);
  //   } catch (error) {
  //     console.error('Failed to fetch users:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getUsers = () => {
    fetch(
      `${baseUrl}/api/userManagement/GetAllUsers?step=0&skip=100&orderBy=refId&order=true&filter=a&currentCountryOnly=false&activeUsersOnly=false`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned Users List', result);
          setDataList(result);
        },
        (error) => {
          notifyPopup(`Error in Getting Users List!: ${error}`, 'error');
        }
      );
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(array, (user) => user.firstName.toLowerCase().includes(query.toLowerCase()));
    }
    return stabilizedThis.map((el) => el[0]);
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleViewClick = (refId) => {
    console.log('here is the ref isd', refId);
    navigate(`/settings/editUser/${refId}`);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: notifyMessage,
      type: notifyType
    });
  };

  const getStatusString = (status) =>
    userStatuses.find((item) => item.refId === status)?.name || 'Unknown';
  const getDepartmentString = (dept) =>
    userDept.find((item) => item.refId === dept)?.name || 'Unknown';

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;
  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);
  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10">
        <Typography component="span" variant="h6" gutterBottom>
          User List
        </Typography>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<NoteAddIcon />}
          onClick={() => navigate('/settings/managetemplates')}
        >
          User Templates
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<NoteAddIcon />}
          onClick={() => navigate('/settings/createUser')}
        >
          Create New User
        </Button>
      </Stack>

      <Card>
        <ClientListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
        />
        {/* <Scrollbar> */}
        <TableContainer>
          <Table size="small" aria-label="user table">
            <ClientListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {filteredUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  const { refId, userName, firstName, emailAddress, status, dept } = row;
                  const isItemSelected = selected.indexOf(refId) !== -1;

                  return (
                    <StyledTableRow
                      hover
                      key={refId}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell padding="checkbox" />
                      <TableCell align="left">{userName}</TableCell>
                      <TableCell align="left">{firstName}</TableCell>
                      <TableCell align="right">{emailAddress}</TableCell>
                      <TableCell align="right">{getStatusString(status)}</TableCell>
                      <TableCell align="right">{getDepartmentString(dept)}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => handleViewClick(refId)}>
                          <VisibilityIcon color="primary" />
                        </IconButton>
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={7} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        {/* </Scrollbar> */}
        <TablePagination
          rowsPerPageOptions={[10, 20, 30]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <Controls.Notification notify={notify} setNotify={setNotify} />
      <Controls.ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
    </Container>
  );
}
